import { Container, Grid } from "@mui/material";
import FairMemberShow from "./FairMemberShow";

const AllFairMember = () => {
  return (
    <>
      <Container sx={{ mt: 4 }} maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <FairMemberShow />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default AllFairMember;
